module.exports = __webpack_public_path__ + "img/list_aha_gpt.6d999eea.png";